import i18n from '@/locales/i18n'

const columns = [
    {
        title: null,
        dataIndex: "index",
        width: "60px",
        align: "center",
        scopedSlots: { customRender: 'index' }
    },
    {
        title: i18n.t('receivableList.importAndExport'),
        dataIndex: "boundType",
        width: "80px",
        align: "center",
        scopedSlots: { customRender: 'receivableBoundType' }
    },
    {
        title: i18n.t('receivableList.subtotal'),
        dataIndex: "chargeSumInfo",
        scopedSlots: { customRender: 'costTem' },
        width: "120px",
        align: "center",
    },
    {
        title: i18n.t('receivableList.boxMakingTime'),
        dataIndex: "planArrivalTime",
        width: "150px",
        align: "center"
    },
    {
        title: i18n.t('receivableList.billNumber'),
        dataIndex: "blNo",
        width: "200px",
        align: "center"
    },
    {
        title: i18n.t('receivableList.containerNumber'),
        dataIndex: "containerNumber",
        width: "120px",
        align: "center"
    },
    {
        title: i18n.t('receivableList.containerSize'),
        dataIndex: "containerSize",
        width: "120px",
        align: "center"
    },
    {
        title: i18n.t('receivableList.portDistrict'),
        dataIndex: "portDistrict",
        width: "100px",
        align: "center"
    },
    {
        title: i18n.t('receivableList.customerName'),
        dataIndex: "customerName",
        width: "250px",
        align: "center"
    },
    {
        title: i18n.t('receivableList.orderCreateTime'),
        dataIndex: "orderCreateTime",
        width: "150px",
        align: "center"
    }
    ,
    {
        title: i18n.t('receivableList.freight'),
        dataIndex: "运费",
        width: "90px",
        align: "center",
        scopedSlots: { customRender: 'costTem' },
    },
    {
        title: i18n.t('receivableList.portEntryFee'),
        dataIndex: "进港费",
        width: "90px",
        align: "center",
        scopedSlots: { customRender: 'costTem' },
    },
    {
        title: i18n.t('receivableList.overweightFee'),
        dataIndex: "超重费",
        width: "90px",
        align: "center",
        scopedSlots: { customRender: 'costTem' },
    },
    {
        title: i18n.t('receivableList.specialBoxFee'),
        dataIndex: "特种箱费",
        width: "90px",
        align: "center",
        scopedSlots: { customRender: 'costTem' },
    },
    // {
    //     title: "封子费",
    //     dataIndex: "unknown",
    //     width: "90px",
    //     align: "center"
    // },
    // {
    //     title: "提箱费",
    //     dataIndex: "unknown",
    //     width: "90px",
    //     align: "center"
    // },
    // {
    //     title: "预提费",
    //     dataIndex: "unknown",
    //     width: "90px",
    //     align: "center"
    // },
    // {
    //     title: "待时费",
    //     dataIndex: "unknown",
    //     width: "90px",
    //     align: "center"
    // }


];



// [
//     {
//         code: "CONFIRMED",
//         value: "已接单"
//     }, {
//         code: "CONFIRMED",
//         value: "已接单"
//     }
// ]

const changeCode = (code, arr) => {
    let value;
    arr.forEach(item => {
        if (item.value === code) {
            value = item.label;
        }
    });
    return value;
}
export {
    columns, changeCode
}